import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import YoutubeEmbed from "../components/YoutubeEmbed";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";
import FormMini from "../components/forms/FormMini";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Operational Monitoring &amp; Management Broker Solutions - Elm Street Technology</title>
        <meta
          name="description"
          content="Elm Street's advanced, all-in-one solutions provide one single point of contact, one single partner, and one single sign-on for managing
the day-to-day."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/broker-solutions" />
        <meta property="og:title" content="Operational Monitoring &amp; Management Broker Solutions - Elm Street Technology" />
        <meta
          property="og:description"
          content="Elm Street's advanced, all-in-one solutions provide one single point of contact, one single partner, and one single sign-on for managing
the day-to-day."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('brokeragebg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "650px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                    Operational Monitoring &amp; Management 
                    </span>{" "}
                    <br />
                    broker solutions
                  </Typography>
                  <p>
                  Elm Street Technology offers broker solutions that help real estate brokers run their business and manage their agents, as well as their clients. Our platform is simple, scalable and affordable, offering everything you need to grow your business while cutting costs and increasing profit.
                  </p>
                  <Button variant="contained" color="secondary" href="#form">
                    schedule a demo
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>



      <div>
        <Container maxWidth="lg" style={{ paddingTop: "90px", paddingBottom: "85px" }}>
          <Grid container columnSpacing={8}>
            <Grid item md={4} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h2">
                one powerful <br />
                <span style={{ color: "#f69c26" }}>solution</span>
              </Typography>
              <br />
              Did you know that to service their brokerage and clients, brokers can use as many as 15 different marketing tools?
<br /><br />
Manage your day-to-day activities with just one point of contact, one partner, and one login with Elm Street's comprehensive, all-in-one solutions.
            </Grid>

            <Grid item md={8} xs={12}>
              <YoutubeEmbed embedUrl="https://www.youtube.com/embed/F1jXTGc2Xng" />
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('brokerages2bg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: "50px",
                  paddingBottom: "50px",
                  height: "480px",
                }}
              >
                <div>
                  <Typography variant="h4" component="h4">
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                      recruitment
                      <br />
                      &amp; retention
                    </span>{" "}
                    tools
                  </Typography>
                  <p>
                  Prospect, recruit, retain, and help your agents from the comfort of our customizable solutions. Stay competitive, confident, and fully staffed with happy agents by helping them "level up." 
                  </p>
                 
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "45px",
            paddingBottom: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/brokerages2.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Brokerages - marketing technology for agents"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    marketing
                    technology
                  </span>
                  <br />
                  for you &amp; your agents
                </Typography>
                <br />
                <span>
                With Elm Street Technology, you have one partner supporting you and your agents with an intuitive CRM, lead generation services, IDX websites, social media, workflow automation, direct mail marketing, and team phone services…all of which are backed by
                exceptional customer service.
                <br /><br />
                <strong style={{ color: "#f69c26" }}>Is it time to streamline your business?</strong><br />
Save time, money, and resources with Elm Street Technology's Brokerage Success Team.<br /><br />
<Button variant="contained" color="secondary" href="#form">
                    explore our office solution
                  </Button>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>



      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "25px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>fast &amp; adaptive</span>
                  <br />
                  onboarding
                </Typography>

                <p>
                Our brokerage partners enjoy the most streamlined and easy-to-use onboarding process available. We support you every step of the way to ensure setup is complete so that your potential for high technology adoption rates is better.
                </p>
            
              </Grid>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/brokerages4.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Brokerages - Easy Onboarding"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/brokerages3.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street For Brokerages - Training &amp; Fanatical Support"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    devoted
                  </span>
                  <br />
                  support &amp; training
                </Typography>

                <p>
                Ensure a smooth transition and ongoing support and training, without the hassle. With our training and support services, we increase agent productivity and education by delivering both in-person and virtual training that will inspire, motivate and generate long-term drive.
                </p>
               
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>




      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule a demo today
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                Connect with Elm Street's Brokerage Success Team today to explore your path to success.
              </strong>
            </div>
            <div style={{ padding: "15px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                  <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou"
                      listId="147986"
                      formName="es2_brokersTeams"
                      fieldList={["first_name", "last_name", "email", "phone", "markets"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
